document.addEventListener('DOMContentLoaded', () => {
    // Your TypeScript code goes here
    console.log('DOM fully loaded and parsed');
});
